import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useCTAButtonVariant } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { useCreatePetitionUpdateContext } from '../../../../../../context';

function AdditionalCtaButton(): JSX.Element | null {
	const { getCTAVariant } = useCTAButtonVariant();

	return (
		<Button size="small" variant={getCTAVariant('secondaryEmphasis')} sx={{ width: '100%' }} aria-disabled>
			<Translate value="corgi.petition_update.preview_modal.share_ask_cta" />
		</Button>
	);
}

export function PreviewEmailCtaButtons(): JSX.Element {
	const isTemplateFilled = useCreatePetitionUpdateContext();

	return (
		<Box px={16}>
			<Button size="small" sx={{ width: '100%' }} mb={isTemplateFilled ? 8 : 0} aria-disabled>
				<Translate value="corgi.petition_update.preview_modal.update_cta" />
			</Button>
			{isTemplateFilled && <AdditionalCtaButton />}
		</Box>
	);
}
